<template>
  <div class="not-found">
    <Header class="main-page__header header-bg container"/>
    <div class="not-found__inner">
        <h1 class="not-found__heading">Страница не найдена</h1>
        <h1 class="not-found__heading">404</h1>
        <p class="not-found__text">Извините, запрашиваемая страница не существует.</p>
        <router-link class="not-found__btn" to="/">Вернуться на главную</router-link>
    </div>
    
  </div>
</template>

<script>
import Header from '@/components/Header'


export default {
    data() {
        return {
            articles: []
        }
    },
    components: {
        Header
    },
}
</script>

<style scoped>
    .main-page__header{
        margin-bottom: 25px;
    }
    .not-found__inner{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        justify-content: center;
        height: calc(100vh - 150px);
    }
    .not-found__btn{
        font-family: "Bona Nova", serif;
        padding: 16px 60px;
        color: #ECDED3;
        background-color: #3A3841;
        border-radius: 20px;
        font-size: 20px;
        transition: all linear .2s;
    }
    .not-found__text{
        margin-bottom: 25px;
    }
    .not-found__btn:hover{
        opacity: .5;
    }
    .not-found__heading{
        margin-bottom: 25px;
    }
</style>